import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { PopUpService, ModalComponent } from 'app/core';
import { GroupQuestion } from '../models/group-question';
import { TutorizationQuestionService } from '../services/tutorization-question.service';
import { TutorizationGroupService } from '../services/tutorization-group.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'lms-group-question-detail',
  templateUrl: './group-question-detail.component.html',
  styleUrls: ['./group-question-detail.component.scss']
})
export class GroupQuestionDetailComponent implements OnInit {
  public question: GroupQuestion;
  public modal: ModalComponent;

  public filters: Map<string, string>;

  public questionsSortingFields = [
    { field: 'name', label: 'questions.sortableFields.name' },
    { field: 'email', label: 'questions.sortableFields.email' }
  ];

  constructor(
    public questionsService: TutorizationQuestionService,
    public route: ActivatedRoute,
    public location: Location,
    public router: Router,
    public translate: TranslateService,
    public popupService: PopUpService,
    public actions: TutorizationGroupService
  ) {}

  ngOnInit() {
    this.route.paramMap
      .pipe(switchMap((params: ParamMap) => this.questionsService.getQuestion(params.get('id'))))
      .subscribe((question) => {
        this.filters = new Map<string, string>().set('questionId', question.id);
        this.question = question;
      });
  }

  goBack(): void {
    this.location.back();
  }

  onUpdateQuestion(question: GroupQuestion) {
    this.question = question;
    this.router.navigate(['/groups', question.groupId], { replaceUrl: true });
  }

  deleteQuestion() {
    this.actions.deleteQuestion(this.question.id);
  }

  cancelQuestion() {
    this.actions.cancelQuestion(this.question.id);
  }

  publishQuestion() {
    this.actions.publishQuestion(this.question.id);
  }

  certifyQuestion() {
    this.actions.certifyQuestion(this.question.id);
  }
}
